export const USER_AUTH_STORAGE_KEY = 'user-auth'
export const BUSINESS_STORAGE_KEY = 'business'
export const SUBSCRIPTION_STORAGE_KEY = 'subscription'
export const SUBSCRIPTION_REFRESHED_STORAGE_KEY = 'subscription-refreshed'
export const SUBSCRIPTION_REFRESH_EXPIRY_DAYS = 3
export const REPORTS_STORAGE_KEY = 'roi-reports'

export function getReportsStorageKey(businessId: string | number) {
  return `${REPORTS_STORAGE_KEY}_${businessId}`
}

export const INSTALL_PROMPT_DISMISSED_KEY = 'install_prompt_dismissed'
export const NOTIFICATIONS_MODAL_DISMISSED_KEY = 'notification_modal_dismissed_v2'
export const AUTH_VERIFICATION_MODAL_DISMISSED_KEY = 'auth_verification_modal_dismissed'
export const BRAND_BLUEPRINT_GATE_DISMISSED_KEY = 'brand_blueprint_gate_dismissed'

export function getBrandBlueprintGateDismissedKey(businessId: string | number) {
  return `${BRAND_BLUEPRINT_GATE_DISMISSED_KEY}_${businessId}`
}
